import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, notification, message } from 'antd';
import { useDispatch } from 'react-redux';
import { getUserDetails, postUserDetails } from '../../../features/UserManagement/UserManagementSlice';

const { Option } = Select;

const AddUser = ({ visible, onOk, onCancel }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const userCategory = ["Admin Pooling Agent", "Pooling Agent"];

  const formFields = [
    { label: 'First Name', name: 'first_name', rules: [{ required: true, message: 'Please input your first name!' }] },
    { label: 'Last Name', name: 'last_name', rules: [{ required: true, message: 'Please input your last name!' }] },
    { label: 'Username', name: 'username', rules: [{ required: true, message: 'Please input your username!' }] },
    { label: 'Email', name: 'email', rules: [{ required: true, type: 'email', message: 'Please enter a valid email!' }] },
    { label: 'Password', name: 'password', inputType: 'password', rules: [{ required: true, message: 'Please enter a valid password!' }] },
    {
      label: 'Re-Enter Password',
      name: 'reenter_password',
      rules: [
        { required: true, message: 'Please re-enter your password!' },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue('password') === value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Passwords do not match!'));
          },
        }),
      ],
      inputType: 'password'
    },
    // { label: 'Contact Number', name: 'contact_number', rules: [{ required: true, message: 'Please input your contact number!' }, { pattern: /^\d{10}$/, message: 'Contact number must be 10 digits!' }] },
  ];

  const onFinish = async (values) => {
    if (submitting) return;

    try {
      setSubmitting(true);
      // console.log(values)

      const response = await dispatch(postUserDetails(values));
      console.log(response)
      if (response.error) {
        throw new Error(response.error.message);
      } else {
        dispatch(getUserDetails())
        notification.success({
          message: 'User Added Successfully',
          description: `User ${values.first_name} ${values.last_name} has been added.`,
        });
      }
      form.resetFields();
      setSubmitting(false);
      await onOk();
    } catch (error) {
      notification.error({
        message: 'Error Adding User',
        description: `There was an error adding the user: ${error.message}`,
      });
      setSubmitting(false);
    }
  };

  return (

    <Modal
      title="Add User"
      visible={visible}
      onCancel={onCancel}
      okText="Submit"
      confirmLoading={submitting}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        layout="vertical"
        name="add_user_form"
        className='add-user-modal-content'
        onFinish={onFinish}
      >
        {formFields.map(({ label, name, rules, inputType }) => (
          <Form.Item key={name} label={label} name={name} rules={rules}>
            {inputType === 'password' ? (
              <Input.Password visibilityToggle={true} />
            ) : (
              <Input />
            )}
          </Form.Item>
        ))}


        <Form.Item
          label="User Type"
          name="user_type"
          rules={[{ required: true, message: 'Please select a user type!' }]}
        >
          <Select
            placeholder="Select a user type"
            allowClear
          >
            {userCategory.map((category) => {
              return (
                <Option key={category} value={category}>
                  {category}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>

  );
};

export default AddUser;
